<template>
  <div class="content" style="padding-top:0px">
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <ul class="navbar-nav">
            <li class="nav-item">
            <router-link class="list-group-item list-group-item-action" v-bind:class="{'active' : data.tabActive === 'odcodp'}" :to="{ name: 'odcodp' }" v-on:click.native="data.tabActive = 'odcodp'">
                ODC
            </router-link>
            </li>
            <li class="nav-item">
            <router-link class="list-group-item list-group-item-action" v-bind:class="{'active' : data.tabActive === 'odp'}" :to="{ name: 'odp' }" v-on:click.native="data.tabActive = 'odp'">
                ODP
            </router-link>
            </li>
        </ul>
    </nav>

    <transition name="slide-fade" mode="out-in"><router-view></router-view></transition>
  </div>
</template>

<script>
import Vue from 'vue'
import vuejsDatepicker from 'vuejs-datepicker'
import moment from 'moment'
import inter from '@/globalFunc/Interface' 
import myGlobal from '@/globalFunc/myGlobal' 
import Loading from '@/globalFunc/Loading' 
import { reactive } from '@vue/composition-api'

Vue.use(moment)

// EXCEL
import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)

export default {
    name: 'Beranda', 
    components: { 
        vuejsDatepicker,
        moment,
        'Loading': Loading
    },
    setup() {
        const data = reactive({
            tabActive: "odcodp"
        })
        return {
            data
        }
    },
    mounted () {
        document.title = "Pelanggan";    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.modal {
	display: inherit;
}
.tombol {
  cursor: pointer;
}
.info {
  position: absolute;
  background-color: #fff;
  border: 1px solid #eee;
  border-radius: 5px;
  padding: 10px;
  z-index: 999999999;
  margin-top: -50px;
}
</style>



// WEBPACK FOOTER //
// src/components/odcodp/main.vue